// @core
import Immutable from 'immutable';
import PropTypes from 'prop-types';

// @components
import NewCardDetails from 'routes/contractsView/components/newCardDetails/newCardDetails';
import PreLeaveModalComponent from 'components/preLeaveModalComponent/preLeaveModalComponent';
import { BringAccountWizard } from "../bringAccountWizard/bringAccountWizard";
import { ErrorStep } from '../errorStep/errorStep';
import { SuccessStep } from '../successStep/successStep';
import { CallMeBack } from 'components/callMeBack/callMeBack';
import { CANCEL_MODAL_EVENT, CLOSE_MODAL_EVENT, CONFIRM_MODAL_EVENT, OPEN_MODAL_EVENT } from "components/preLeaveModalComponent/constants"

// @helper
import { getCardDetails } from "../../helpers/bringAccountHelper";

// @constants
import { LOCAL_STATE, STATUSES } from "../../constants/bringAccountConstants";
import { getTaggingErrorStep, getTaggingSuccessStep, taggingPreLeaveModal } from '../../helpers/bringAccountTagging';

export const BringAccountFlowContent = ({ immAccount, immBringAccount, immProfile, immFlagBasedFeatures, isOffice, hasInterveners, isPrivateWeb, history, actions }) => {
    const localState = LOCAL_STATE;

    if (!hasInterveners) {
        return null;
    }

    if (immBringAccount.get('status') === STATUSES.ERROR) {
        return <ErrorStep accountId={immAccount.get('accountId')} tealium={getTaggingErrorStep(immAccount)} />
    }

    if (immBringAccount.get('status') === STATUSES.SAVED) {
        return <SuccessStep immBringAccount={immBringAccount} actions={actions} isOffice={isOffice} isPrivateWeb={isPrivateWeb} tealium={getTaggingSuccessStep(immAccount)} />
    }

    const wizardState = Immutable.fromJS({
        promotionalCode: "",
        interveners: [],
        card_details: getCardDetails(immAccount, immBringAccount, immProfile),
        name: "bring-account",
        visibleStep: immBringAccount.get('currentStep'),
    });

    return (
        <>
            <div className="col-xs-12 col-md-8">
                <BringAccountWizard
                    immBringAccount={immBringAccount}
                    immProfile={immProfile}
                    immAccount={immAccount}
                    isOffice={isOffice}
                    isPrivateWeb={isPrivateWeb}
                    history={history}
                    actions={actions}
                />
            </div>
            <div className="col-xs-12 col-md-4">
                <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                    <div>
                        <NewCardDetails
                            clearInterveners={() => { }}
                            immCommercialAds={{}}
                            immHireCardImageSelector={{}}
                            immProfileFields={immProfile}
                            immFlagBasedFeatures={immFlagBasedFeatures}
                            originCountry={immProfile.get('originCountry')}
                            wizardState={wizardState}
                            localState={localState}
                        />
                    </div>
                </div>
                <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                    <CallMeBack context="contracts" modifier="contracts-view" />
                </div>
            </div>
            <PreLeaveModalComponent
                taggingEvents={{
                    [OPEN_MODAL_EVENT]: taggingPreLeaveModal(OPEN_MODAL_EVENT),
                    [CLOSE_MODAL_EVENT]: taggingPreLeaveModal(CLOSE_MODAL_EVENT),
                    [CONFIRM_MODAL_EVENT]: taggingPreLeaveModal(CONFIRM_MODAL_EVENT),
                    [CANCEL_MODAL_EVENT]: taggingPreLeaveModal(CANCEL_MODAL_EVENT)
                }}
                confirmationMessage='transfer_account-transfer_account_from_another_bank_exit_modal_subtitle'
                confirmationTitle='transfer_account-transfer_account_from_another_bank_exit_modal_title'
                acceptText='transfer_account-transfer_account_from_another_bank_exit_modal_accept_button'
                cancelText='transfer_account-transfer_account_from_another_bank_exit_modal_cancel_button'
                footerType="navigation"
                isReady={() => { return false }}
                onCloseCallback={() => {}}
            />
        </>
    );
}

BringAccountFlowContent.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immBringAccount: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    isOffice: PropTypes.bool.isRequired,
    isPrivateWeb: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
};
